import { KybDocument, KybDocumentType } from '__generated__/GQL';

interface GetCompanyPapersErrorsProps {
  kybDocuments: Pick<KybDocument, 'type' | 'errorLocalized'>[];
}

const getCompanyPapersErrors = ({
  kybDocuments,
}: GetCompanyPapersErrorsProps) =>
  kybDocuments
    .filter(
      ({ errorLocalized, type }) =>
        Boolean(errorLocalized) &&
        [
          KybDocumentType.Kbis,
          KybDocumentType.CompanyRegistrationOfficialPaper,
        ].includes(type),
    )
    .map(({ errorLocalized }) => errorLocalized) as string[];

export default getCompanyPapersErrors;
